// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Ix","side":"e_Jx","main":"e_Kx","reversed":"e_Lx"};